import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '~/components/Modal/Modal';
import { CustomerListMatchingAttribute } from '~/types/api.graphql';

import { DroppedRulesList, WarningText } from './MatchingRulesField.styles';
import RuleTitle from './RuleTitle';

interface BackToSimpleConfirmationProps {
  /** Each rule the simple view would remove, as its `[index, columnName, attribute]` fields. */
  droppedRules: Array<Array<[number, string, CustomerListMatchingAttribute | undefined]>>;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Asked before **Back to simple matching** removes rules the simple view can't show */
const BackToSimpleConfirmation = ({
  droppedRules,
  onConfirm,
  onCancel,
}: BackToSimpleConfirmationProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      open
      width="28rem"
      title={t('aiInsights.a2ui.matchingRules.backToSimpleTitle')}
      submitButtonTitle={t('aiInsights.a2ui.matchingRules.removeAndGoBack')}
      onSubmit={onConfirm}
      onClose={onCancel}
    >
      <WarningText>{t('aiInsights.a2ui.matchingRules.backToSimpleConfirm')}</WarningText>
      <DroppedRulesList>
        {droppedRules.map((fields) => (
          <li key={fields.map(([index]) => index).join('-')}>
            <RuleTitle fields={fields} />
          </li>
        ))}
      </DroppedRulesList>
    </Modal>
  );
};

export default BackToSimpleConfirmation;
